import React from 'react';
import { NavLink } from 'react-router-dom';
import { Tab } from '@mui/material';
import { useStyles } from '../styles/navigationTabStyles';

const CustomNavLink = React.forwardRef(({ ...rest }, ref) => {
  const classes = useStyles();
  return (
    <NavLink
      {...rest}
      innerRef={ref}
      className={(arg) => `${rest?.className} ${arg?.isActive ? classes.activeTab : ''}`}
    />
  );
});

const CustomTab = ({ ...rest }) => {
  const classes = useStyles();
  return <Tab component={CustomNavLink} {...rest} className={classes.routeTab} />;
};

export default CustomTab;
